// Generated by CoffeeScript 1.12.7
//require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');
/* global document:false, navigator: false */
function setCursorPosition(pos) {
  let elem, range;
  if (this.length > 0) {
    elem = this.get(0);
    if (elem != null) {
      if (elem.setSelectionRange != null) {
        elem.setSelectionRange(pos, pos);
      } else if (elem.createTextRange != null) {
        range = elem.createTextRange();
        range.collapse(true);
        range.moveEnd('character', pos);
        range.moveStart('character', pos);
        range.select();
      }
    }
  }
}

function placeholderInput() {
  const inputField = this;
  const nativePlaceholder =
    document.createElement('input').placeholder !== void 0 &&
    navigator.appVersion.indexOf('MSIE') === -1;
  if (!nativePlaceholder && inputField.getAttribute('placeholder') != null) {
    inputField.addEventListener('keypress', function() {
      if (this.value === this.getAttribute('placeholder')) {
        this.style.color = '#333333';
        this.value = '';
      }
    });
    inputField.addEventListener('keyup', function() {
      if (this.value !== '') {
        if (this.value !== this.getAttribute('placeholder')) {
          this.style.color = '#333333';
        }
      } else {
        this.style.color = '#888888';
        this.value = inputField.getAttribute('placeholder');
        this.setCursorPosition(0);
      }
    });
    if (inputField.value === '') {
      inputField.style.color = '#888888';
      inputField.value = inputField.getAttribute('placeholder');
      inputField.setCursorPosition(0);
    }
  }
}

Object.defineProperty(Object.prototype, 'setCursorPosition', {
  value: setCursorPosition,
  writable: true,
  configurable: true,
  enumerable: false,
});

Object.defineProperty(Object.prototype, 'placeholderInput', {
  value: placeholderInput,
  writable: true,
  configurable: true,
  enumerable: false,
});
